import './altochecks'
require("./inicio")
require("./nosotros")
require('./clientes')
require('./soluciones/popups')


